import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-500/10 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4 no-underline">
              <span className="text-xl font-bold font-heading text-foreground-950 tracking-tight">
                娜娜<span className="text-primary-500">轻量版</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              轻盈体验，高效触达。为追求极简高效的用户打造的轻量化解决方案。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">文章分类</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">文章分类</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/product-updates" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">产品动态</Link>
              </li>
              <li>
                <Link to="/category/tutorials" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">使用教程</Link>
              </li>
              <li>
                <Link to="/category/efficiency-tips" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">效率技巧</Link>
              </li>
              <li>
                <Link to="/category/industry-news" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">行业资讯</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系方式</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-primary-500"></i>
                <span>contact@nanalite.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-phone-line text-primary-500"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-map-pin-line text-primary-500"></i>
                <span>北京市朝阳区科技园区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 娜娜轻量版 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">帮助中心</a>
          </div>
        </div>
      </div>
    </footer>
  );
}